import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=5e2cd291&scoped=true"
import script from "./Accounting.vue?vue&type=script&lang=js"
export * from "./Accounting.vue?vue&type=script&lang=js"
import style0 from "./Accounting.vue?vue&type=style&index=0&id=5e2cd291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2cd291",
  null
  
)

export default component.exports